import React from "react";
import Step1 from "../formComponents/form26/Step1";
import Step2 from "../formComponents/form26/Step2";
import Step3 from "../formComponents/form26/Step3";
import Step4 from "../formComponents/form26/Step4";
import "../styles/Form26.css";

const Form26 = () => {
  return (
    <div>
      <Step1 />
      <Step2 />
      <Step3 />
      <Step4 />
    </div>
  );
};

export default Form26;
